import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GirisGuard } from './guards/giris.guard';
import { GirisFormComponent } from './modules/giris/giris-form/giris-form.component';
import { GirisComponent } from './modules/giris/giris.component';
import { BulunamadiComponent } from './modules/hata/bulunamadi/bulunamadi.component';
import { AnasayfaComponent } from './modules/site/anasayfa/anasayfa.component';
import { SiteComponent } from './modules/site/site.component';
import { KullaniciTalepAyrintiComponent } from './modules/yonetim/kullanici-talep-bilgi/kullanici-talep-ayrinti/kullanici-talep-ayrinti.component';
import { KullaniciTalepBilgiComponent } from './modules/yonetim/kullanici-talep-bilgi/kullanici-talep-bilgi.component';
import { KullaniciTalepIslemComponent } from './modules/yonetim/kullanici-talep-bilgi/kullanici-talep-islem/kullanici-talep-islem.component';
import { ProfilIslemComponent } from './modules/yonetim/profil/profil-islem/profil-islem.component';
import { ProfilComponent } from './modules/yonetim/profil/profil.component';
import { YonetimAnasayfaComponent } from './modules/yonetim/yonetim-anasayfa/yonetim-anasayfa.component';
import { YonetimComponent } from './modules/yonetim/yonetim.component';

const routes: Routes = [
  {
    path: 'giris', component: GirisComponent, children: [
      { path: '', component: GirisFormComponent }
    ]
  },
  {
    path: 'site', component: SiteComponent, children: [
      { path: '', component: AnasayfaComponent }
    ]
  },  
  {
    path: '', component: YonetimComponent, children: [
      { path: '', component: YonetimAnasayfaComponent, canActivate: [GirisGuard] },
      {
        path: 'talep-list', children: [
          { path: '', component: KullaniciTalepBilgiComponent, canActivate: [GirisGuard], data: { roller: [] } },
          { path: ':id', component: KullaniciTalepIslemComponent, canActivate: [GirisGuard] },
        ]
      },
      {
        path: 'profil', children: [
          { path: '', component: ProfilComponent, canActivate: [GirisGuard], data: { roller: [] } },
          { path: ':id', component: ProfilIslemComponent, canActivate: [GirisGuard] },
        ]
      }, 
      {
        path: 'talep-ayrinti', children: [
          { path: ':id', component: KullaniciTalepAyrintiComponent, canActivate: [GirisGuard] },
        ]
      },
    ]
  },  
  {
    path: '**',
    component: BulunamadiComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
